import "./helpers/networkInterceptor";
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { useRoutes } from "react-router-dom";
import AppRoutes from "./routes";
import config from "config/config";
import * as Ably from "ably";
import { AblyProvider, ChannelProvider } from "ably/react";
import { NavProvider } from "components/common/Navbar/NavContext";
import { CopilotKit } from "@copilotkit/react-core";
import { useAppDispatch, useAppSelector } from "hooks/storeHooks";
import { AgentType } from "enums/AgentTypeEnum";
const client = new Ably.Realtime({ key: config.ABLY_API_KEY });

function App() {
    const dispatch = useAppDispatch();
    const allRoutes = useRoutes(AppRoutes());

    const { fetchChatThreadSuccess: threadId, agentType } = useAppSelector((state) => state.chat);

    return (
        <>
            <CopilotKit
                agent={
                    agentType === AgentType.NewProductForecaster
                        ? AgentType.NewProductForecaster
                        : "synth-gpt"
                }
                runtimeUrl={`${config.API_URL}/copilotkit`}
                publicApiKey={config.COPILOT_API_KEY}
                threadId={agentType === AgentType.NewProductForecaster ? "" : threadId}
            >
                <AblyProvider client={client}>
                    <Toaster
                        position="top-right"
                        containerStyle={{
                            zIndex: 999999999, // for toast to appear above modal
                        }}
                    />
                    <NavProvider>
                        <ChannelProvider channelName="campaign">
                            <div className="App">{allRoutes}</div>
                        </ChannelProvider>
                    </NavProvider>
                </AblyProvider>
            </CopilotKit>
        </>
    );
}

export default App;
